import React, { useState, useEffect, useRef } from "react";
import IconDropdown from "../../icons/IconDropdown";
import IconInfo from "../../icons/IconInfo";
import IconCross from "../../icons/IconCross";
import DropdownFilter from "./DropdownFilter";

const ElementProductFinder = (props) => {

  const {
    configs,
    notes
  } = props.configs;


  const [questions, setQuestions] = useState([]);
  const [popup, setPopup] = useState(false);
  const [product, setProduct] = useState(false);


  useEffect(() => {
    setQuestions([configs]);
  }, []);

  const onSelectOption = (option, index) => {
    const q = [...questions];
    q.splice(index + 1, q.length - (index + 1));
    if (option.next) {
      q.push(option.next);
    }
    if (option.product) {
      setProduct(option.product)
    }
    setQuestions(q);
  }


  const handleClosePopup = () => {
    setViewProducts(false);
    setShowPopup(false)
  }

  return <>
    <div className="container">
      <div className="productFinder__container">
        <div className="productFinder__wrapper">
          <div className="productFinder__left">
            <div className="productFinder__questions">
              {questions.map((question, index) => {
                return <DropdownFilter
                  level={question}
                  onSelect={(option) => {
                    onSelectOption(option, index)
                  }} />
              })}
            </div>
            {!!notes && <div className="productFinder__important" onClick={() => setPopup(true)}>
              <div className="productFinder__important__icon">
                <IconInfo />
              </div>
              <div className="productFinder__important__test">
                <p>Important Notes</p>
              </div>
            </div>}
          </div>
          {!!product && <div className="productFinder__right">
            <div className="productFinder__product">
              {product.image && <div className="productFinder__product__image">
                <img src={product.image} alt={product.title} />
              </div>}
              <div className="productFinder__product__content">
                <div className="productFinder__product__prefix">
                  <h6>{product.model}</h6>
                </div>
                <div className="productFinder__product__title typography">
                  <h5>{product.title}</h5>
                </div>
                <div
                  className="productFinder__product__desc typography"
                  dangerouslySetInnerHTML={{__html: product.brief}}
                />
                <div
                  className="productFinder__product__action"
                >
                  <button
                    className="btn"
                    onClick={() => {
                      if (notes) {
                        setPopup(true)
                      } else {
                        window.location = product.link;
                      }
                    }}
                  >
                    Learn More
                  </button>
                </div>
              </div>
            </div>
          </div>}
        </div>
      </div>
    </div>
    {popup && <div className="productFinder__popup">
      <div className="productFinder__popup__wrapper">
        <div className="productFinder__popup__header">
          <p>Important Notes</p>
          <div onClick={() => setPopup(false)} className="productFinder__popup__close"><IconCross /></div>
        </div>
        <div className="productFinder__popup__Content">
          <div
            className="productFinder__popup__desc typography"
            dangerouslySetInnerHTML={{__html: notes}}
          />
        </div>
        {!!product && (
          <div className="productFinder__popup__footer">
            <a href={product.link} className="btn">View Product</a>
          </div>
        )}
        {!product && (
          <div className="productFinder__popup__footer">
            <button className="btn" onClick={() => setPopup(false)} >close</button>
          </div>
        )}
      </div>
    </div>}
  </>
};

export default ElementProductFinder;
